var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.737061C2.51472 0.737061 0.5 2.75178 0.5 5.23706V20.9992C0.5 23.4845 2.51472 25.4992 5 25.4992H20.0486C22.5339 25.4992 24.5486 23.4845 24.5486 20.9992V5.23706C24.5486 2.75178 22.5339 0.737061 20.0486 0.737061H5Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.517 5.50159C8.54114 5.50159 5.32153 8.8615 5.32153 13.0014C5.32153 17.1413 8.54114 20.5012 12.517 20.5012C16.5001 20.5012 19.7269 17.1413 19.7269 13.0014C19.7269 8.8615 16.5001 5.50159 12.517 5.50159ZM12.5242 19.0012C9.34063 19.0012 6.76207 16.3163 6.76207 13.0014C6.76207 9.68647 9.34063 7.00155 12.5242 7.00155C15.7078 7.00155 18.2864 9.68647 18.2864 13.0014C18.2864 16.3163 15.7078 19.0012 12.5242 19.0012ZM15.0452 12.2514C15.643 12.2514 16.1256 11.7489 16.1256 11.1264C16.1256 10.504 15.643 10.0015 15.0452 10.0015C14.4473 10.0015 13.9648 10.504 13.9648 11.1264C13.9648 11.7489 14.4473 12.2514 15.0452 12.2514ZM10.0033 12.2514C10.6011 12.2514 11.0837 11.7489 11.0837 11.1264C11.0837 10.504 10.6011 10.0015 10.0033 10.0015C9.40546 10.0015 8.92288 10.504 8.92288 11.1264C8.92288 11.7489 9.40546 12.2514 10.0033 12.2514ZM12.5242 17.1263C14.2025 17.1263 15.6286 16.0313 16.2048 14.5013L8.84365 14.5013C9.41986 16.0313 10.846 17.1263 12.5242 17.1263Z",
    fill: "#7E898F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2866,
    height: 17.9994,
    fill: "white",
    transform: "translate(3.8811 4.00159)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiBoxed);
export default __webpack_public_path__ + "static/media/EmojiBoxed.ae3d9585a57d7e78704fa98563c5b5a6.svg";
export { ForwardRef as ReactComponent };